'use client'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { ConsentGroup, useIsConsentGroupEnabled } from '@marketplace-web/consent/consent-feature'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'

import RoktAdvertisement from '../RoktAdvertisement'
import VanOfferAdvertisement from '../VanOfferAdvertisement'
import VanMultiOfferAdvertisement from '../VanMultiOfferAdvertisement'
import useIsTransactionEligibleForAd from '../../../hooks/useIsTransactionEligibleForAd'

const OfferAdvertisement = () => {
  const isOfferAdvertisementEnabled = useFeatureSwitch('web_offer_advertisement')
  const isMultiOfferEnabled = useFeatureSwitch('web_multi_offer')

  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)
  const hasConsentedPersonalisedAds = useIsConsentGroupEnabled(ConsentGroup.PersonalisedAds)

  const shouldUserSeeAds = useAbTest('sqp_ads')?.variant === 'on'

  const isRoktScriptEnabled = useFeatureSwitch('web_ads_rokt_script')
  const hasConsentedRokt = useIsConsentGroupEnabled(ConsentGroup.RoktAdvertising)

  const { transaction, conversation } = useConversationContext()
  const transactionId = transaction?.id
  const purchaseId = conversation?.transaction?.purchaseId
  const isEligibleForAd = useIsTransactionEligibleForAd(transactionId, purchaseId)

  const shouldShowRokt =
    isRoktScriptEnabled &&
    shouldUserSeeAds &&
    hasConsentedRokt &&
    hasConsentedTargeting &&
    hasConsentedPersonalisedAds

  const shouldTrackAbTest = shouldUserSeeAds && isMultiOfferEnabled && isEligibleForAd

  const multiOffersTest = useAbTest('multi_offers')

  useTrackAbTest(multiOffersTest, shouldTrackAbTest)

  const shouldShowMultiOffers = isMultiOfferEnabled && multiOffersTest?.variant === 'on'

  if (!isEligibleForAd) return null

  if (!isOfferAdvertisementEnabled) return <RoktAdvertisement />

  if (shouldShowRokt) return <RoktAdvertisement />

  return shouldShowMultiOffers ? <VanMultiOfferAdvertisement /> : <VanOfferAdvertisement />
}

export default OfferAdvertisement
